/* eslint-disable no-undef, no-unused-vars, import/first */

//app-with-player-libraries.js and app.js files almost identical
//app.js does not have huge libraries so we are using app.js to reduce package size
//in the future we need to make, that these files are not duplicated

import languageBundle from '@kirschbaum-development/laravel-translations-loader/php?parameters={$1}!@kirschbaum-development/laravel-translations-loader';
import Aos from 'aos';
import './imports';
import VueI18n from 'vue-i18n';
import store from './store';
import HandleDestroyRequest from './helpers/HandleDestroyRequest';
import Cart from './components/Shop/Cart';
import SmallCart from './components/Shop/SmallCart';
import Payment from './components/Shop/Payment';

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: window.Locale,
  messages: languageBundle
});

const app = new Vue({
  name: 'App',
  store,
  i18n,

  components: {
    Cart,
    SmallCart,
    Payment
  },

  mounted() {
    this.$nextTick(() => {
      HandleDestroyRequest.bind();
    });
  },
  methods: {
    openCookieConsentModal() {
      VueEventHub.$emit('open-cookie-consent-modal');
    },
    swal(params) {
      Swal.fire(params);
    }
  }
}).$mount('#app');

Aos.init();
